import { Navigate, Outlet } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { useAuth } from "./AuthContext";
export default function ProtectedRoute() { const { session, loading } = useAuth(); if (loading) return <div className="flex justify-content-center p-6"><ProgressSpinner /></div>; return session ? <Outlet /> : <Navigate to="/signin" replace />; }
